import { useMemo, useState } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import styled from "styled-components";
import { z } from "zod";
import { Button } from "../../atoms/Button";
import { Input } from "../../atoms/Input";
import FormTemplate from "../../templates/FormTemplate";

type Props = {
  handleSubmit: (text: string) => void;
};

export const SearchStoreByTextForm: React.FC<Props> = ({ handleSubmit }) => {
  const schema = useMemo(() => {
    return z.object({
      text: z.string().min(1),
    });
  }, []);

  const [methods, setMethods] = useState<UseFormReturn<
    FieldValues,
    any,
    undefined
  > | null>(null);

  return (
    <FormTemplate
      schema={schema}
      setMethods={setMethods}
      defaultValues={{
        text: "",
      }}
      onSubmit={({ text }) => handleSubmit(text)}
    >
      <InputContainer>
        <Input name="text" type="text" placeholder="例:東京" required />
      </InputContainer>

      <ButtonContainer>
        <Button type="submit" text="店舗検索" btnStyle="primary" />
      </ButtonContainer>
    </FormTemplate>
  );
};

const InputContainer = styled.div`
  padding: 0;
  margin-bottom: 18px;
  input {
    border-radius: 8px;
  }
`;

const ButtonContainer = styled.div`
  button {
    height: auto;
    padding: 20px 0 18px;
    width: 320px;
    font-weight: 600;
    border-radius: 8px;
  }
`;
